module.exports = __webpack_public_path__ + "static/media/number03.3e36acc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/number03.svg
// module id = 929
// module chunks = 0